import { CLEAR_FAVORITE_FILES, FETCH_FAVORITE_FILES, SET_FAVORITE_FILES } from "../actions";

const initialState = {
    favoriteFilesData: null,
    isLoading: false,
    error: null,
};

const favoriteFilesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_FAVORITE_FILES:
            return { ...state, isLoading: true, error: null };

        case SET_FAVORITE_FILES:
            return { ...state, favoriteFilesData: action.payload, isLoading: false, error: null };

        case CLEAR_FAVORITE_FILES:
            return { ...state, favoriteFilesData: null, isLoading: false, error: null };

        default:
            return state;
    }
};

export default favoriteFilesReducer;
